import { render, staticRenderFns } from "./SideworkPanel.vue?vue&type=template&id=547693a2&scoped=true&"
import script from "./SideworkPanel.vue?vue&type=script&lang=js&"
export * from "./SideworkPanel.vue?vue&type=script&lang=js&"
import style0 from "./SideworkPanel.vue?vue&type=style&index=0&id=547693a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547693a2",
  null
  
)

export default component.exports